/**
 * 后端应用地址
 * @type {string}
 */
export const URL_BASE = process.env.VUE_APP_API_URL;
/**
 * 公共页面，未登录状态也可访问
 * @type {string[]}
 */
export const PUBLIC_PAGES = [
    '/login',
    '/user/password-update',
    '/permission-error'
];

/**
 * 旧版 v1 的网址
 * @type {string}
 */
export const VERSION_OLD_URL = process.env.VUE_APP_API_URL_OLD;
